import { render, staticRenderFns } from "./plan_chart.vue?vue&type=template&id=589376bc&scoped=true"
import script from "./plan_chart.vue?vue&type=script&lang=js"
export * from "./plan_chart.vue?vue&type=script&lang=js"
import style0 from "./plan_chart.vue?vue&type=style&index=0&id=589376bc&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "589376bc",
  null
  
)

export default component.exports